import { BASE_URL } from "@/api/system/param"
import { createFormItem } from "@/component-create/utils/create-form-item"
import { FormDialog } from "@/component-create/FormDialog"
import { FORM_ITEM } from "@/components/form/enums"

/**
 * 绘制新增表单
 */
 export function renderEditForm(el: Element) {
  const addForm = new FormDialog(
    el, 
    { 
      items: items, 
      elFormProps: { rules: rules }, 
      saveUrl: BASE_URL,
      saveMethods: 'put',
      loadUrl: BASE_URL
    },
    '编辑'
  )

  return addForm
}

const items = [
  [
    createFormItem('参数名称', 'paramName', FORM_ITEM.INPUT, { clearable: true, maxlength: '20' })
  ],
  [
    createFormItem('键', 'paramKey', FORM_ITEM.INPUT, { clearable: true})
  ],
  [
    createFormItem('值', 'paramValue', FORM_ITEM.INPUT, { clearable: true })
  ],
  [
    createFormItem('状态', 'status', FORM_ITEM.SELECT, { loader: 'EOD', default: true, }),
    null
  ],
  [
    createFormItem('备注', 'remark', FORM_ITEM.INPUT, { type: 'textarea', rows: 3, maxlength: '200', showWordLimit: true }),
  ]
]

const rules = {
  paramName: [{ required: true, message: '请输入参数名称', trigger: 'blur' }],
  paramKey: [{ required: true, message: '请输入参数键', trigger: 'blur' }],
  paramValue: [{ required: true, message: '请输入参数值', trigger: 'blur' }],
  status: [{ required: true, message: '请选择参数状态', trigger: 'blur' }]
}